export default {
  functionKey: "NB.SI",
  title: "NB.SI",
  group: "Calcul",
  origin: [],
  target: [],
  targetRequired: true,
  multiOrigin: true,
  arguments: [],
  maxArguments: 1,
  requiredArguments: [{ argumentKey: "Criterion", name: "Critère" }],
  expectedArguments: [
    { name: "Critère", argumentKey: "Criterion", single: true, initialValue: "" }
  ],
  description: "Compte les colonnes dont la valeur correspond au critère. Ajoutez les colonnes en Origine, le critère en Argument.",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol, allOrigins = []) {
    const cols = allOrigins.length > 0 ? allOrigins : (origin ? [origin] : []);
    const criterion = args[0] || "''";
    if (cols.length === 0) return { displayCode: '', safeCode: '' };
    const safeCode = `${destination}=String([${cols.join(',')}].filter(function(v){return String(v)===String(${criterion});}).length);`;
    return { displayCode: safeCode, safeCode };
  }
}
